import React, { useEffect, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import { Box } from "@mui/material";
import UserTable from "../../../Components/Table/UserTable";
import { GetUser } from "../../../APIs/Function/User/GetUser";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";
import { GetPremiumUser } from "../../../APIs/Function/User/GetPremiumUser";

const PremiumUsers = () => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const handleUser = async () => {
    try {
      setLoading(true);
      let res = await GetPremiumUser();
      setUserData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }
    try {
      await SearchDebouncing(1, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleUser();
  }, []);

  return (
    <>
      <Box sx={{ p: 2, boxSizing: "border-box" }}>
        <Searchbar placeholder={"Search User"} onChange={handleSearch} />

        <Box>
          {searched && searchData.length > 0 ? (
            <UserTable
              setUserData={setUserData}
              userData={searchData}
              loading={loading}
            />
          ) : (
            <UserTable
              setUserData={setUserData}
              userData={userData}
              loading={loading}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default PremiumUsers;
